import { useEffect } from "react";

// Router
import { Redirect, useHistory } from "react-router-dom";

// Redux
import { useSelector, useDispatch } from "react-redux";
import * as actionTypes from "../../redux/actions/actionTypes";
import { authAjax, updateAuthenticated } from "../../redux/actions/auth";
import { RootState } from "../../redux/store";

import useLandingRoute from "../../custom-hooks/useLandingRoute";

// UI Components
import { ErrorLoader, Loader, SuccessLoader } from "../../UI/Loaders/Loaders";

// Child Components
import LoginForm from "../LoginForm/LoginForm";

// Styles
import "./Login.css";
import Enter2FACode from "../../modals/Modals/Enter2FACode/Enter2FACode";
import ChangeExpiredPassword from "../../modals/Modals/ChangeExpiredPassword/ChangeExpiredPassword";
import { getObjectFromLocalStorage } from "../../helpers/localStorage";

type TLoginProps = {
  username: string;
  password: string;
  code?: string;
};

const Login = () => {
  const { isAuthenticated, loading, error, success } = useSelector(
    (state: RootState) => state?.authReducer,
  );
  const loggedInUser = getObjectFromLocalStorage("loggedInUser");

  const { getLandingRoute } = useLandingRoute();

  const dispatch = useDispatch();
  const history = useHistory();
  const queryParams = new URLSearchParams(window.location.search);
  const mfaSetupSuccess = queryParams.get("mfaSetupSuccess");

  const authHandler = (loginData: TLoginProps) => {
    dispatch(authAjax(loginData));
  };

  const enterHandler = () => {
    window.addEventListener("keyup", function (event) {
      // 13 is the "Enter" key on the keyboard
      if (event.keyCode === 13) {
        // Cancel default action
        event.preventDefault();
        // Trigger the button element with a click
        // Trigger the button element with a click
        let loginTrigger = document.querySelector(
          "#loginButton",
        ) as HTMLElement;
        if (loginTrigger) {
          loginTrigger.click();
        }
      }
    });
  };

  // useEffect(() => {
  //   const keyUpHandler = (event: KeyboardEvent) => {
  //     if (event.key === "Enter") {
  //       event.preventDefault();
  //       const loginTrigger = document.querySelector("#loginButton") as HTMLElement;
  //       loginTrigger?.click();
  //     }
  //   };
  //
  //   window.addEventListener("keyup", keyUpHandler);
  //
  //   return () => window.removeEventListener("keyup", keyUpHandler);
  // }, []);

  useEffect(() => {
    enterHandler();

    if (isAuthenticated) {
      if (mfaSetupSuccess) {
        dispatch({ type: actionTypes.AUTH_LOGOUT });
        history.push("/login");
      } else if (
        loggedInUser &&
        loggedInUser.mfaSetupRequired &&
        !mfaSetupSuccess
      ) {
        history.push("/enable-2fa");
      } else {
        history.push(getLandingRoute());
      }
    }
  }, []);

  let renderedComponent = null;

  if (loading) {
    renderedComponent = <Loader text="Verifying your Credentials" />;
  } else if (error) {
    if (error.error_code) {
      if (
        error.error_code === 401 &&
        error?.message?.toLowerCase() === "mfa is required"
      ) {
        renderedComponent = <Enter2FACode onAuth={authHandler} />;
      } else if (
        error.error_code === 401 &&
        error?.message?.toLowerCase() ===
          "password has expired. please proceed to change your password"
      ) {
        renderedComponent = (
          <ChangeExpiredPassword errorMessage={error?.message} />
        );
      } else if (error.error_code === 400 || error.error_code === 401) {
        renderedComponent = (
          <ErrorLoader
            text="Wrong Login Credentials"
            subText={error?.message}
          />
        );
      }
    } else {
      renderedComponent = (
        <ErrorLoader
          icon="fas fa-wifi"
          text="Network Issue"
          subText="Unable to connect to Advancly services."
        />
      );
    }

    if (
      error?.message?.toLowerCase() !== "mfa is required" &&
      error?.message?.toLowerCase() !==
        "password has expired. please proceed to change your password"
    ) {
      setTimeout(() => {
        renderedComponent = <LoginForm onAuth={authHandler} />;
        dispatch(updateAuthenticated(false));
      }, 3000);
    }
  } else if (success) {
    renderedComponent = (
      <div className="tfx-user-form-wrapper box-effect full-border white-bg animated fadeInRight">
        <SuccessLoader
          text="Logged In Successfully"
          subText="You will be redirected to your dashboard
                              shortly."
        />
      </div>
    );

    setTimeout(() => {
      dispatch(updateAuthenticated(true));
    }, 3000);
  } else if (isAuthenticated) {
    if (mfaSetupSuccess) {
      dispatch({ type: actionTypes.AUTH_LOGOUT });
      history.push("/login");
    } else if (
      loggedInUser &&
      loggedInUser.mfaSetupRequired &&
      !mfaSetupSuccess
    ) {
      history.push("/enable-2fa");
    } else {
      renderedComponent = <Redirect to={getLandingRoute()} />;
    }
  } else {
    renderedComponent = (
      <div className="adv-form-bg">
        <LoginForm onAuth={authHandler} />
      </div>
    );
  }

  return (
    <div className="Login center-container  normal-1x zoomIn">
      <div className="center-container-wrapper">
        <div className="">{renderedComponent}</div>
      </div>
    </div>
  );
};

export default Login;
